<script setup lang="ts">
import {ref} from "vue";

withDefaults(defineProps<{
  hasMore?: boolean;
}>(), {
  hasMore: true,
});

const showMore = ref(false);

const toggleMore = () => {
  showMore.value = !showMore.value;
};

const onBeforeEnter = (el: Element) => {
  (el as HTMLElement).style.height = '0px';
};

const onEnter = (el: Element) => {
  const target = el as HTMLElement;
  requestAnimationFrame(() => {
    target.style.transition = 'height 300ms ease';
    target.style.height = `${target.scrollHeight}px`;
  });
};

const onAfterEnter = (el: Element) => {
  const target = el as HTMLElement;
  target.style.transition = '';
  target.style.height = 'auto';
};

const onBeforeLeave = (el: Element) => {
  const target = el as HTMLElement;
  target.style.height = `${target.scrollHeight}px`;
};

const onLeave = (el: Element) => {
  const target = el as HTMLElement;
  requestAnimationFrame(() => {
    target.style.transition = 'height 300ms ease';
    target.style.height = '0px';
  });
};

const onAfterLeave = (el: Element) => {
  (el as HTMLElement).style.transition = '';
};
</script>

<template>
  <button
      v-if="hasMore && !showMore"
      type="button"
      class="flex w-full items-center gap-3 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536] mt-2"
      aria-expanded="false"
      @click="toggleMore"
  >
    <span class="h-px flex-1 bg-[#e7ddcc]"></span>
    <span
        class="flex items-center gap-1.5 text-xs font-medium tracking-[0.1px] whitespace-nowrap text-parameter-text cursor-pointer">
      <slot name="more-label">Mehr anzeigen</slot>
      <svg aria-hidden="true" viewBox="0 0 12 12" fill="none" class="size-2.5 shrink-0 text-[#555956]">
        <path d="m1.5 4 4.5 4 4.5-4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <span class="h-px flex-1 bg-[#e7ddcc]"></span>
  </button>
  <Transition
      @before-enter="onBeforeEnter"
      @enter="onEnter"
      @after-enter="onAfterEnter"
      @before-leave="onBeforeLeave"
      @leave="onLeave"
      @after-leave="onAfterLeave"
  >
    <div v-if="showMore" class="w-full overflow-hidden">
      <div class="flex flex-col w-full mt-2">
        <slot></slot>
        <button
            type="button"
            class="mt-4 flex w-full items-center gap-3 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]"
            aria-expanded="true"
            @click="toggleMore"
        >
          <span class="h-px flex-1 bg-[#e7ddcc]"></span>
          <span
              class="flex items-center gap-1.5 text-xs font-medium tracking-[0.1px] whitespace-nowrap text-parameter-text">
            <slot name="less-label">Weniger anzeigen</slot>
            <svg aria-hidden="true" viewBox="0 0 12 12" fill="none"
                 class="size-2.5 shrink-0 rotate-180 text-[#555956]">
              <path d="m1.5 4 4.5 4 4.5-4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="h-px flex-1 bg-[#e7ddcc]"></span>
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>

</style>
